import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { Text } from "@chakra-ui/react";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import NewTable from "components/NewTable";
import useMovimentacoesBancarias from "features/movimentacoes-bancarias/hooks/useMovimentacoes";
import { MovimentacaoBancariaItem } from "features/movimentacoes-bancarias/typings";
import { RepasseDiarioItemResponse } from "features/repasse/typings";
import moment from "moment";
import useMovimentacoesBancariasColumns from "../../../MovimentacoesBancarias/Listagem/hooks/useMovimentacoesBancariasColumns";
import { defaultFiltroMovimentacoesBancarias } from "../../../MovimentacoesBancarias/Listagem/hooks/useFiltroMovimentacoesBancarias";

type ModalTransacoesRepasseDiaProps = {
  isOpen: boolean;
  onClose: () => void;
  dataIso: string | null;
  repasseDia: RepasseDiarioItemResponse | null;
  contasBancariasIds: string[];
};

function ModalTransacoesRepasseDia({
  isOpen,
  onClose,
  dataIso,
  repasseDia,
  contasBancariasIds,
}: ModalTransacoesRepasseDiaProps) {
  const columns = useMovimentacoesBancariasColumns();

  const { data: movimentacao, isLoading } = useMovimentacoesBancarias(
    {
      ...defaultFiltroMovimentacoesBancarias,
      dataInicio: dataIso ?? defaultFiltroMovimentacoesBancarias.dataInicio,
      dataFim: dataIso ?? defaultFiltroMovimentacoesBancarias.dataFim,
      contasBancariasIds,
      onlyRepasse: true,
    },
    {
      enabled: Boolean(
        isOpen && dataIso && contasBancariasIds.length > 0
      ),
    }
  );

  const items: MovimentacaoBancariaItem[] =
    dataIso && movimentacao ? movimentacao.items : [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxH="90vh">
        <ModalHeader>
          Movimentações em{" "}
          {dataIso ? moment(dataIso).format("DD/MM/YYYY") : ""}
          {repasseDia ? (
            <Text fontSize="sm" fontWeight="normal" mt={1}>
              Repasse do dia: R$ {formatCurrency(repasseDia.valor)}
            </Text>
          ) : null}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <NewTable<MovimentacaoBancariaItem>
            loading={Boolean(dataIso) && isLoading}
            columns={columns}
            dataSource={items}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default ModalTransacoesRepasseDia;
